import { useMemo } from 'react';

import { indexRoute, useItemState, getItemAction, updateItemAction, deleteItemAction, axios } from './utils';

const baseUrl = '/templates/notifications';
const allowedParams = [
  'clientId',
  'name',
  'type',
  'emailSubject',
  'emailTemplate',
  'smsTemplate',
  'active',
  'enabled',
  'status',
];

const templates = {
  index: indexRoute(baseUrl),
  item: (id, params, { history, lazy } = {}) => {
    const url = `${baseUrl}/${id}`;
    const [item, setItem] = useItemState(url, params);
    const get = getItemAction(url, { params, setItem });
    const update = updateItemAction(url, {
      allowedParams,
      item,
      setItem,
      onSuccess: () => get(null, 'update'),
    });
    const del = deleteItemAction(url, { setItem, history });

    useMemo(() => {
      if (!lazy) get();
    }, []);

    return { item, actions: { get, update, delete: del } };
  },
};

const patchTemplateFields = ['smsTemplate', 'emailTemplate', 'emailSubject', 'status'];

export const saveNotificationTemplate = async (data, id) => {
  const template = { ...data };
  delete template.whatsAppTemplate;
  delete template.name;
  if (!id) {
    delete template.type;
  } else {
    if (!template.status) template.status = 'enabled';
    Object.keys(template).forEach((key) => {
      if (!patchTemplateFields.includes(key)) delete template[key];
    });
  }
  const body = { template };
  const res = id ? await axios.patch(`${baseUrl}/${id}`, body) : await axios.post(baseUrl, body);
  return res.data.data;
};

const clientField = (client, key) => {
  if (!client) return null;
  if (client.get) return client.get(key);
  return client[key];
};

const clientPreferences = (client) => {
  const prefsSource = clientField(client, 'preferences');
  return prefsSource && prefsSource.toJS ? prefsSource.toJS() : { ...(prefsSource || {}) };
};

const patchClientPreferences = async (clientId, client, nextPreferences) => {
  const res = await axios.patch(`/clients/${clientId}`, {
    client: {
      name: clientField(client, 'name'),
      preferences: JSON.stringify(nextPreferences),
    },
  });
  return res.data;
};

export const assignClientNotificationTemplate = async (clientId, client, preferenceKey, templateId) => {
  const nextPreferences = { ...clientPreferences(client), [preferenceKey]: Number(templateId) };
  return patchClientPreferences(clientId, client, nextPreferences);
};

export const unassignClientNotificationTemplate = async (clientId, client, preferenceKey) => {
  const nextPreferences = { ...clientPreferences(client) };
  delete nextPreferences[preferenceKey];
  return patchClientPreferences(clientId, client, nextPreferences);
};

export const removeNotificationTemplate = async (id) => {
  const res = await axios.delete(`${baseUrl}/${id}`);
  return res.data;
};

export default templates;